module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list",
    class: _vm.pagination && !_vm.pagination.totalCount ? 'list--unpaged' : ''
  }, [(!_vm.hideActions || !_vm.hideSearch) ? _c('menu', {
    staticClass: "list__controls list__controls--spread"
  }, [_c('button', {
    staticClass: "button button--border",
    class: {
      'button--hidden': _vm.hideActions
    }
  }, [_c('span', {
    staticClass: "button__label"
  }, [_vm._v("Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "list__menu"
  }, [(!_vm.hideSearch) ? _c('fieldset', {
    staticClass: "list__search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "list__input",
    attrs: {
      "id": "search",
      "type": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.triggerSearch($event)
      }]
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "icon icon--search",
    attrs: {
      "for": "search"
    }
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.hideSearch) ? _c('AdvancedSearch', {
    attrs: {
      "searchCriterias": _vm.searchCriterias
    },
    on: {
      "search": _vm.triggerSearch
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.hideActions || !_vm.hideCreate || !_vm.hideExport) ? _c('menu', {
    staticClass: "list__controls list__controls--spread"
  }, [_c('button', {
    staticClass: "button button--border",
    class: {
      'button--hidden': _vm.hideActions
    }
  }, [_c('span', {
    staticClass: "button__label"
  }, [_vm._v("Actions")])]), _vm._v(" "), _c('div', {
    staticClass: "list__menu"
  }, [(!_vm.hideCreate) ? _c('button', {
    staticClass: "button list__button",
    attrs: {
      "data-acc": "create"
    },
    on: {
      "click": function($event) {
        return _vm.triggerAction('create')
      }
    }
  }, [_c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.L.localize('Label_Create')))])]) : _vm._e(), _vm._v(" "), (!_vm.hideExport) ? _c('button', {
    staticClass: "list__button button button--light",
    on: {
      "click": function($event) {
        return _vm.triggerAction('export', _vm.searchQueries)
      }
    }
  }, [_c('span', {
    staticClass: "button__label"
  }, [_vm._v(_vm._s(_vm.L.localize('Label_Export')) + "\n          "), _c('i', {
    staticClass: "icon icon--export"
  })])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.progressValue > 0) ? _c('ProgressBar', {
    attrs: {
      "max": _vm.progressMax,
      "percent": _vm.progressValue
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "list__content"
  }, [_c('table', [(_vm.fields.length) ? _c('thead', {
    staticClass: "list__header"
  }, [_c('tr', {
    staticClass: "list__row",
    style: (_vm.columns ? _vm.columns[_vm.i] : '')
  }, _vm._l((_vm.fields), function(field) {
    return _c('td', {
      key: field.label,
      staticClass: "list__field list__field--header"
    }, [_vm._v("\n            " + _vm._s(field.label ? field.label : field.prop) + "\n          ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    staticClass: "list__body",
    attrs: {
      "appear": "",
      "name": _vm.transition,
      "tag": "tbody"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "list__row list__row--item"
    }, [_vm._l((_vm.fields), function(field) {
      return [(field.html) ? _c('td', {
        key: field.label,
        staticClass: "list__field",
        domProps: {
          "innerHTML": _vm._s(_vm.showItem(field, item))
        },
        on: {
          "click": function($event) {
            return _vm.triggerAction('detail', item, $event)
          }
        }
      }) : (item.__url) ? _c('td', {
        key: field.label,
        staticClass: "list__field-with-href",
        attrs: {
          "data-acc": _vm.showItem(field, item).toString().toLowerCase()
        }
      }, [_c('router-link', {
        staticClass: "list__href",
        attrs: {
          "to": item.__url
        }
      }, [_vm._v("\n                  " + _vm._s(_vm.showItem(field, item)) + "\n              ")])], 1) : _c('td', {
        key: field.label,
        staticClass: "list__field",
        attrs: {
          "data-acc": _vm.showItem(field, item).toString().toLowerCase()
        },
        on: {
          "click": function($event) {
            return _vm.triggerAction('detail', item, $event)
          }
        }
      }, [_vm._v("\n              " + _vm._s(_vm.showItem(field, item)) + "\n            ")])]
    })], 2)
  }), 0), _vm._v(" "), (!_vm.data.length && !_vm.isLoading) ? _c('tr', {
    staticClass: "list__row list__row--item"
  }, [_c('td', {
    staticClass: "list__field list__field--no-data",
    attrs: {
      "data-acc": "test",
      "colspan": _vm.fields.length
    }
  }, [_vm._v("\n          " + _vm._s(_vm.L.localize("Label_NoData")) + "\n        ")])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('tr', {
    staticClass: "list__row list__row--item"
  }, [_c('td', {
    staticClass: "list__field list__field--no-data",
    attrs: {
      "colspan": _vm.fields.length
    }
  }, [_c('spinner', {
    attrs: {
      "lightColor": true,
      "contained": true
    }
  })], 1)]) : _vm._e()], 1)]), _vm._v(" "), (_vm.pagination && _vm.pagination.totalCount && _vm.paginationRange.length > 1) ? _c('nav', {
    staticClass: "list__controls"
  }, [(_vm.pagination.currentPage != 1) ? _c('button', {
    staticClass: "list__prev",
    on: {
      "click": _vm.prevPage
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.paginationRange), function(n) {
    return _c('span', {
      key: n,
      staticClass: "list__page",
      class: n === _vm.pagination.currentPage ? 'list__page--active' : '',
      on: {
        "click": function($event) {
          return _vm.goToPage(n)
        }
      }
    }, [_vm._v("\n      " + _vm._s(n) + "\n    ")])
  }), _vm._v(" "), (_vm.pagination.currentPage !== _vm.pagination.totalPage) ? _c('button', {
    staticClass: "list__next",
    on: {
      "click": _vm.nextPage
    }
  }) : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-75277fa8!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/list/List.vue
// module id = 746
// module chunks = 1